const MEETING = {
  REMIND_OPTIONS: [
    {
      label: '开始时提醒',
      value: 'on_time'
    },
    {
      label: '提前5分钟提醒',
      value: 'before_5'
    },
    {
      label: '提前10分钟提醒',
      value: 'before_10'
    },
    {
      label: '提前15分钟提醒',
      value: 'before_15'
    },
    {
      label: '提前20分钟提醒',
      value: 'before_20'
    },
    {
      label: '提前30分钟提醒',
      value: 'before_30'
    },
    {
      label: '无提醒',
      value: 'none'
    }
  ],
  TYPE_OPTIONS: [
    {
      label: '外部-商务',
      value: 1
    },
    {
      label: '内部-问题与决策（含评审）',
      value: 2
    },
    {
      label: '内部-例行会议（周总、月总等）',
      value: 3
    },
    {
      label: '其他（培训、面试、访谈等）',
      value: 4
    }
  ],
  // 最大上传数量
  FILE_MAX_COUNT: 10,
  // 最大上传数量，M
  FILE_MAX_SIZE: 10
};

export default MEETING;
